import React, { useEffect, useState } from 'react'
import { userAPI } from '../services/api'
import { useAuth } from '../contexts/AuthContext'

const ProfileSettingsPage = () => {
  const { user, isAuthenticated, updateUser } = useAuth()
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    mobile: '',
  })
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    const load = async () => {
      if (!isAuthenticated) return
      try {
        setLoading(true)
        const res = await userAPI.getProfile()
        if (res.data?.success) {
          const u = res.data.data || {}
          setForm({
            firstName: u.firstName || '',
            lastName: u.lastName || '',
            mobile: u.mobile || '',
          })
        }
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [isAuthenticated])

  const onSubmit = async (e) => {
    e.preventDefault()
    try {
      setSaving(true)
      const res = await userAPI.updateProfile(form)
      if (res.data?.success && res.data?.data) {
        updateUser(res.data.data)
      }
      alert('Profile updated successfully')
    } catch (err) {
      alert(err?.response?.data?.message || 'Failed to update profile')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">Profile Settings</h1>
      {loading ? (
        <div className="flex items-center justify-center py-16">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-6 bg-white p-6 rounded-lg border">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">First name</label>
              <input
                type="text"
                value={form.firstName}
                onChange={(e) => setForm((p) => ({ ...p, firstName: e.target.value }))}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Last name</label>
              <input
                type="text"
                value={form.lastName}
                onChange={(e) => setForm((p) => ({ ...p, lastName: e.target.value }))}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Mobile</label>
            <input
              type="tel"
              value={form.mobile}
              onChange={(e) => setForm((p) => ({ ...p, mobile: e.target.value }))}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
            >
              {saving ? 'Saving...' : 'Save changes'}
            </button>
          </div>
        </form>
      )}
    </div>
  )
}

export default ProfileSettingsPage


